import React, { useEffect, useState } from "react";
import { List, Typography, Spin, Alert, Dropdown, Menu, Button, Popconfirm, message } from "antd";
import { MoreOutlined } from "@ant-design/icons";

const { Text } = Typography;

const RecipeMethodList = ({
  recipeMethodIngredients,
  onEditMethod,
  onDeleteMethod,
  readonly = false, // <-- add default if not provided
  portions,
  requiredportions
}) => {
  const [methods, setMethods] = useState([]);
  const [loading, setLoading] = useState(Boolean(recipeMethodIngredients));
  const [error, setError] = useState(null);
  const [conversionfactor, setConversionFactor] = useState(1);

  useEffect(() => {
    if (!recipeMethodIngredients) {
      setMethods([]);
      setLoading(false);
      return;
    }
    const sorted = [...recipeMethodIngredients].sort(
      (a, b) => a.recipeMethod.order - b.recipeMethod.order
    );
    setMethods(sorted);
    setLoading(false);
    if (readonly && requiredportions && portions && portions > 0) {
  setConversionFactor(requiredportions / portions);
} else {
  setConversionFactor(1);
}

  }, [recipeMethodIngredients, readonly, requiredportions, portions]);

  if (loading) return <Spin tip="Loading recipe methods..." />;
  if (error) return <Alert type="error" message={error} />;

  const getMenu = (item, idx) => (
    <Menu>
      <Menu.Item key="edit" onClick={() => onEditMethod(item, idx)}>
        Edit
      </Menu.Item>
      <Menu.Item key="delete">
        <Popconfirm
          title="Are you sure you want to delete this step?"
          onConfirm={() => onDeleteMethod(item)}
          okText="Yes"
          cancelText="No"
        >
          Delete
        </Popconfirm>
      </Menu.Item>
    </Menu>
  );

return (
  <List
    style={{ 
      maxWidth: 700, 
      margin: 'auto', 
      background: 'rgba(255,255,255,0.85)', 
      borderRadius: 12, 
      boxShadow: '0 4px 32px rgba(0,0,0,0.06)',  
      padding: '24px', 
      border: '2px solid #fff' 
    }}
    bordered
    dataSource={methods}
    renderItem={(item, idx) => {
      // Conversion logic for readonly mode
      let displayQuantity = item?.methodIngredient?.quantity ?? '';
      if (readonly && conversionfactor !== 1 && item?.methodIngredient?.quantity != null) {
        const value = item.methodIngredient.quantity * conversionfactor;
        displayQuantity = value % 1 === 0 ? value.toString() : value.toFixed(2);
      }
      
      return (
        <List.Item
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start'
          }}
        >
          {/* Left content */}
          <div style={{ flex: 1 }}>
            <span>
              <strong>Step {item?.recipeMethod?.order || idx + 1}:</strong>{" "}
              <div style={{ whiteSpace: 'pre-line' }}>
                {item?.recipeMethod?.description || "No description"}
              </div>
            </span>
            {item?.ingredients && item.ingredients.length > 0 && (
              <ul style={{ marginTop: 8 }}>
                {item.ingredients.map((ingredient, i) => {
                  // Apply conversion to each ingredient quantity
                  let ingredientDisplayQuantity = ingredient?.methodIngredient?.quantity ?? '';
                  if (readonly && conversionfactor !== 1 && ingredient?.methodIngredient?.quantity != null) {
                    const value = ingredient.methodIngredient.quantity * conversionfactor;
                    ingredientDisplayQuantity = value % 1 === 0 ? value.toString() : value.toFixed(2);
                  }
                  
                  return (
                    <li key={ingredient?.methodIngredient?.id || i}>
                      {ingredientDisplayQuantity}{" "}
                      {ingredient?.methodIngredient?.quantityType}{" "}
                      {ingredient?.food?.name}
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
          {/* Right kebab menu -- render only if not readonly */}
          {!readonly && (
            <div>
              <Dropdown key="menu" overlay={getMenu(item, idx)} trigger={["click"]}>
                <Button icon={<MoreOutlined />} type="text" aria-label="More actions" />
              </Dropdown>
            </div>
          )}
        </List.Item>
      );
    }}
    locale={{ emptyText: "No methods found for this recipe." }}
  />
);

};

export default RecipeMethodList;
